import React, { Component } from 'react';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as regex from '../../../constants/regex';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';
import * as strings from '../../constants/strings';
import { dropDownDefault } from '../../constants/webAppointmentConstants'
import dobFormatting from '../../../shared/functions/dobFormatting';

export class PolicyHolderPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rerender: 1
    };
  }

  isValid() {
    let valid = (
      this.props.insurance.policyHolder.relation && this.props.insurance.policyHolder.relation !== strings.SOMEONE_ELSE &&
      this.props.insurance.policyHolder.firstName &&
      this.props.insurance.policyHolder.lastName &&
      this.props.insurance.policyHolder.dob &&
      this.props.insurance.policyHolder.dob.match(regex.DATE_OF_BIRTH_REGEX) &&
      this.props.insurance.policyHolder.email &&
      this.props.insurance.policyHolder.email.match(regex.EMAIL_REGEX)
    );

    return !!valid;
  }

  render() {
    const title = "Please provide the policy holder’s information.";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: 'select',
            id: 'relation',
            key: 'relation',
            label: "Policy holder’s relationship to " + (this.props.forMe ? "you" : "the patient"),
            onChange: (value) => {
              this.props.webAppointmentSetInsuranceHolderRelation(value === dropDownDefault ? "" : value);
            },
            existingContent: this.props.insurance.policyHolder.relation || undefined,
            required: true,
            requiredError: "Please select the policy holder’s relationship to " + (this.props.forMe ? "you." : "the patient."),
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            options: [
              { name: dropDownDefault, value: undefined },
              { name: 'Parent', value: 'Parent' },
              { name: 'Guardian', value: 'Guardian' },
              { name: 'Spouse', value: 'Spouse' },
              { name: 'Partner', value: 'Partner' },
              { name: 'Child', value: 'Child' },
              { name: 'Sibling', value: 'Sibling' },
              { name: 'Relative', value: 'Relative' },
              { name: 'Friend', value: 'Friend' },
              { name: 'Other', value: 'Other' }
            ]
          }
        ]
      },   // end of fieldset.

      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            {
              type: 'text',
              id: 'firstName',
              label: "Policy holder’s first name",
              onChange: (ev) => { this.props.webAppointmentSetInsuranceHolderFname(ev.target.value); },
              existingContent: this.props.insurance.policyHolder.firstName || undefined,
              required: true,
              requiredError: "Please enter the policy holder’s first name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              maxLength: '140'
            },
          ],
          [
            {
              type: 'text',
              id: 'lastName',
              label: "Policy holder’s last name",
              onChange: (ev) => { this.props.webAppointmentSetInsuranceHolderLname(ev.target.value); },
              existingContent: this.props.insurance.policyHolder.lastName || undefined,
              required: true,
              requiredError: "Please enter the policy holder’s last name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              maxLength: '140'
            }
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            {
              id: 'dob',
              key: "dob-" + this.state.rerender,
              type: 'text',
              label: "Policy holder’s date of birth",
              helperText: "Date format: mm/dd/yyyy",
              placeholderText: 'mm/dd/yyyy',
              required: true,
              requiredError: "Please enter the policy holder’s date of birth.",
              patternMatch: regex.DATE_OF_BIRTH_REGEX,
              patternMatchError: "Please enter a valid date",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => { this.props.webAppointmentSetInsuranceHolderDob(ev.target.value); },
              onKeyUp: (ev) => {
                dobFormatting(ev, this, this.props.webAppointmentSetInsuranceHolderDob);
              },
              existingContent: this.props.insurance.policyHolder.dob || undefined
            }
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            {
              type: 'text',
              id: 'email',
              label: "Policy holder’s email",
              required: true,
              requiredError: "Please enter the policy holder’s email address in this format: yourname@example.com",
              patternMatch: regex.EMAIL_REGEX,
              patternMatchError: "Please enter the policy holder’s email address in this format: yourname@example.com",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => {
                const formattedEmail = ev.target.value.replace(/\s/g, '');
                this.props.webAppointmentSetInsuranceHolderEmail(formattedEmail);
                return formattedEmail;
              },
              existingContent: this.props.insurance.policyHolder.email || undefined,
              maxLength: '140'
            }
          ]
        ]
      },  // end of fieldset
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      }  // end of fieldset
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

PolicyHolderPage.propTypes = {
  insurance: defaultState.insurancePropType,
  forMe: PropTypes.bool.isRequired,

  webAppointmentSetInsuranceHolderRelation: PropTypes.func.isRequired,
  webAppointmentSetInsuranceHolderFname: PropTypes.func.isRequired,
  webAppointmentSetInsuranceHolderLname: PropTypes.func.isRequired,
  webAppointmentSetInsuranceHolderDob: PropTypes.func.isRequired,
  webAppointmentSetInsuranceHolderEmail: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    insurance: state.webAppointmentForm.insurance,
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetInsuranceHolderRelation: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceHolderRelation(value)),
    webAppointmentSetInsuranceHolderFname: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceHolderFname(value)),
    webAppointmentSetInsuranceHolderLname: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceHolderLname(value)),
    webAppointmentSetInsuranceHolderDob: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceHolderDob(value)),
    webAppointmentSetInsuranceHolderEmail: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceHolderEmail(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(PolicyHolderPage);
